import { render, staticRenderFns } from "./ServicesReservationAddedServiceForm.vue?vue&type=template&id=1b078a67&scoped=true&"
import script from "./ServicesReservationAddedServiceForm.vue?vue&type=script&lang=js&"
export * from "./ServicesReservationAddedServiceForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b078a67",
  null
  
)

export default component.exports